import { useAuthStore } from '@auth/authStore';
import { DataPage } from '@features/datapage';
import { fetchAssets } from './assets.api';
import { assetsColumns, assetsFilters } from './assets.columns';
import { useNavigate } from 'react-router';
import { getRowValue } from '@lib/rowValues';

function AssetsPage() {
  const navigate = useNavigate();
  const companyID = useAuthStore((state) => state.companyID);
  const updateSite = useAuthStore((state) => state.updateSite);
  const updateAsset = useAuthStore((state) => state.updateAsset);

  function handleDrawerButton(row) {
    const siteId = getRowValue(row, ['WindFarmID', 'site_id', 'WindFarmName']);
    updateSite(siteId);
    const assetId = getRowValue(row, ['WTID', 'asset_id', 'Asset']);
    updateAsset(assetId);
    navigate(`/assets/${encodeURIComponent(assetId)}?siteID=${encodeURIComponent(siteId)}`);
  }

  return (
    <div className='basicWrapper'>
      <DataPage
        title="Assets"
        fetchData={() => fetchAssets(companyID)}
        columns={assetsColumns}
        columnFilters={assetsFilters}
        onDrawerButtonAction={(row) => handleDrawerButton(row)}
        actionLabel="View Asset"
        includeMap
      />
    </div>
  );
}

export default AssetsPage;
